import { useQuery } from "@tanstack/react-query"

import { TableCell, TableRow } from "@/components/ui/table"

import { getLiveDigesterData } from "../api/getLiveDigesterData"

import LiveDigesterMetricDisplay from "./LiveDigesterMetricDisplay"

import type { DigesterConfig, LiveDigesterMetric, MetricColorRange } from "../types/feedstockTypes"

export default function LiveDigesterMetricRow({
  row,
  metric,
  colorRanges,
  digesters,
}: {
  row: number
  metric: LiveDigesterMetric
  colorRanges: MetricColorRange[]
  digesters: DigesterConfig[]
}) {
  const { data, isPending } = useQuery({
    queryKey: ["liveDigesterMetrics", { row }],
    queryFn: () => getLiveDigesterData(digesters, row),
    refetchInterval: 1000,
  })
  let total: number | undefined = undefined
  if (metric.total == "Sum" && data) {
    total = data.reduce((a, c) => (a || 0) + (Number.isFinite(c) ? c || 0 : 0))
  } else if (metric.total == "Average" && data) {
    const sum = data.reduce((a, c) => (a || 0) + (Number.isFinite(c) ? c || 0 : 0))
    if (sum !== undefined) total = sum / data.length
  }

  return (
    <TableRow>
      <TableCell className="p-4">{metric.label}</TableCell>
      {digesters.map((d, i) => (
        <TableCell key={d.key} className="w-[80px] p-4">
          <LiveDigesterMetricDisplay
            value={data ? data[i] : undefined}
            isLoading={isPending}
            colorRanges={colorRanges}
            type={metric.type}
          />
        </TableCell>
      ))}
      <TableCell className="w-[80px] p-4 font-semibold">
        <LiveDigesterMetricDisplay
          value={total}
          isLoading={isPending}
          colorRanges={[]}
          type={metric.type}
        />
      </TableCell>
    </TableRow>
  )
}
